import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class BookingService {


    static addBooking(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addBooking}`;
        return axiosInstance
            .post(api, data)
    }

    static getBookings(item) {

        let api = `${API_BASE_URL}${API_PATHS.getBookings}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.leadId) params.append("leadId", item.leadId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getupcomingBookings(item) {

        let api = `${API_BASE_URL}${API_PATHS.getupcomingBooking}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.toDate) params.append("toDate", item.toDate);
        if (item?.fromDate) params.append("fromDate", item.fromDate);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }


    static getVendorPayments(item) {

        let api = `${API_BASE_URL}${API_PATHS.getVendorPayments}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.leadId) params.append("leadId", item.leadId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }


    static getCustomerPayments(item) {

        let api = `${API_BASE_URL}${API_PATHS.getCustomerPayments}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.leadId) params.append("leadId", item.leadId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addcustomerpayment(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addcustomerpayment}`;
        return axiosInstance
            .post(api, data)
    }
    static addvendorpayment(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addvendorpayment}`;
        return axiosInstance
            .post(api, data)
    }

    static generateinvoice(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.generateinvoice}`;
        return axiosInstance
            .post(api, data)
    }


    static sendInvoice(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendInvoice}`;
        return axiosInstance
            .post(api, data)
    }

    static getInvoice(item) {

        let api = `${API_BASE_URL}${API_PATHS.getInvoice}`;

        const params = new URLSearchParams();

        if (item?.bookingId) params.append("bookingId", item.bookingId);
        if (item?.id) params.append("id", item.id);


        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }



}

export default BookingService;
